<a *ngIf="object"
   class="btn btn-primary"
   ngbTooltip="{{'submission.workflow.tasks.claimed.edit_help' | translate}}"
   [routerLink]="['/workflowitems/' + (object.workflowitem | async)?.payload?.id + '/edit']"
   role="button">
  <span aria-hidden="true" class="fa fa-edit"></span> {{'submission.workflow.tasks.claimed.edit' | translate}}
</a>
